export default __webpack_public_path__ + "static/media/Parent_Illustrations-10.81d34df5.svg";